import React, { useMemo, useState } from "react";
import { Dimensions, Platform, TouchableOpacity, View } from "react-native";
import BoilerPlate from "../boilerPlate/BoilerPlate";
import { BorderRadiusTokens, ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import CustomHeader from "../../customHeader/CustomHeader";
import Typography from "../../typography/Typography";
import Icon from "../../icon/Icon";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import { ModalAlignmentEnum } from "@voltmoney/types";
import { GoogleSignin } from "@react-native-google-signin/google-signin";
import ButtonBase from "../../button/Button.base";
import GoogleLogin from "react-google-login";
import { isFontMobile, isMobile } from "../../stack/utils";
import NeedHelpDC from "../NeedHelpDC";
import BottomSheet from "../BottomSheet";
import { getParameters, getScreenType, isFromTDLPlatform } from "../utils";
const EmailVerifyScreen = ({ id, height, label = "Continue with Google", clientID = '62646021413-queb1g13go0snvnotl0ee06t68jcgb98.apps.googleusercontent.com', needHelpAction, goBackAction, googleAction, emailAction, triggerAction, contactUsDetails, showErrorModal, errorDescription, closeModal, isFromJupiter }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [modalHeight, setModalHeight] = useState(220);
    let isDarkMode = null;
    if (Platform.OS === 'web') {
        let params = getParameters(window.location.href);
        isDarkMode = params?.isDarkMode;
    }
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const isfromTDL = isFromTDLPlatform();
    const handleCloseModal = async () => {
        if (closeModal)
            await triggerAction(closeModal);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { goBackId: 'bt_verifyEmailScreen_goBack', needHelpId: 'bt_verifyEmailScreen_needHelp', title: '', needHelpAction: handleNeedHelp, isDarkMode: isDarkMode ? true : false, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true, hideGoBack: isFromJupiter ? true : false }));
    }, []);
    const onResponse = async (response) => {
        await triggerAction({
            ...googleAction,
            payload: {
                ...googleAction.payload,
                value: Platform.OS === 'web'
                    ? response?.profileObj?.email
                    : response?.user?.email,
            },
        });
    };
    const mobileSignIn = async () => {
        try {
            await GoogleSignin.hasPlayServices();
            const userInfo = await GoogleSignin.signIn();
            await onResponse(userInfo);
        }
        catch (error) {
            console.warn('Google error-> ', error);
        }
    };
    const _renderGoogleButton = (onPress) => (React.createElement(ButtonBase, { id: "bt_verifyEmailScreen_google", onPress: onPress, stack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
        }, bgColor: ColorTokens.Transparent, labelColor: ColorTokens.Primary_100, label: label, fontFamily: FontFamilyTokens.Inter, borderColor: ColorTokens.Primary_100, borderRadius: isfromTDL ? BorderRadiusTokens.BR2 : BorderRadiusTokens.BR5, fontSize: isFontMobile() ? FontSizeTokens.MD : FontSizeTokens.SM, lineHeight: isFontMobile() ? 24 : 20, width: ButtonWidthTypeToken.FULL, iconName: IconTokens.GoogleSVG, icon: {
            name: IconTokens.GoogleSVG,
            size: IconSizeTokens.MD,
        }, paddingVertical: SizeTypeTokens.SM, paddingHorizontal: SizeTypeTokens.MD }));
    const GoogleButton = () => {
        if (Platform.OS === 'web') {
            return (React.createElement(GoogleLogin, { clientId: clientID, render: (renderProps) => _renderGoogleButton(renderProps.onClick), buttonText: 'Login', onSuccess: onResponse, onFailure: onResponse, cookiePolicy: 'single_host_origin', isSignedIn: false }));
        }
        else {
            return _renderGoogleButton(mobileSignIn);
        }
    };
    const modalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, zIndex: 1, flex: 1 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: IconTokens.SystemError })),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center, label: "Verification failed!" })),
            React.createElement(View, { style: { marginTop: 2 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, label: errorDescription })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { id: "bt_confirmPanScreen_reEnterDetails", sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Edit details', onPress: handleCloseModal, isDisabled: false }))));
    };
    const footerChild = () => {
        return showErrorModal ? (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                zIndex: 99
            } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: handleCloseModal, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: Platform.OS === 'web' ? false : true }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: "Verify your email", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 4 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "We\u2019ll use this to send important updates.", color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { marginTop: 32 } },
                React.createElement(GoogleButton, null)),
            React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
                    if (emailAction)
                        triggerAction(emailAction);
                }, style: { marginTop: 20, flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 4, borderColor: '#1434CB', borderWidth: 1, borderRadius: isfromTDL ? 8 : 1000 } },
                React.createElement(Icon, { name: IconTokens.Email, size: IconSizeTokens.MD, color: ColorTokens.Primary_100 }),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Typography, { id: "bt_verifyEmailScreen_otherEmail", typeDLS: TypographyTypeDLS.B0B, label: "Continue with other email", color: ColorTokens.Primary_100 })))));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            footerChild(),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default EmailVerifyScreen;
